export const common = {
  ourServices: "Our Services",
  services: "Services",
  details: "details",
  accountsInUk: "Accountants in uk",
  accountsInUkText:
    "We provide our clients with the expertise, resources, and support they need to manage all aspects of their accounting with confidence. Our team ensures every detail is handled accurately and on schedule, offering personalised service and reliable results. With our commitment to getting the numbers right the first time, you can focus on your business while we take care of the rest.",
  weSpeak: "We speak your language",
  whoWeHelp: "Who do we help?",
  viewDetails: "View details",
  whyChooseUs: "Why choose us?",
  contactUs: "Contact Us",
  soleTrader: "Sole trader",
  limitedCompanies: "Limited Companies",
  partnership: "Partnership",
  quickLinks: "Quick Links",
  aboutUs: "About Us",
  blog: "Blog",
  seeMore: "See more",
  backToBlog: "Back to blog",
  noPosts: "No posts yet.",
  postNotFound: "Post not found.",
  blogLoadError: "Could not load posts. Please try again later.",
  prevPage: "Previous page",
  nextPage: "Next page",
  pagination: "Pages",
  contactFormName: "Name *",
  contactFormPhone: "Phone *",
  contactFormEmail: "Email (optional)",
  contactFormMessage: "Message *",
  contactFormSend: "Send message",
  contactFormSending: "Sending...",
  contactFormSent: "Your message has been sent. We'll get back to you soon.",
  contactFormAnother: "Send another message",
  contactFormError: "Could not send your message. Please try again later or contact us directly.",
};
